export * from "ce/sagas/HomeSagas";
import { all, takeLatest } from "redux-saga/effects";
import {
  getRecentlyCaseSaga,
  getQuickAccessSaga,
  pinApplicationSaga
} from "ce/sagas/HomeSagas";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";

export default function* homeSagas() {
  yield all([
    takeLatest(ReduxActionTypes.FETCH_RECENTLY_CASE_INIT, getRecentlyCaseSaga),
    takeLatest(ReduxActionTypes.FETCH_QUICK_ACCESS_INIT, getQuickAccessSaga),
    takeLatest(ReduxActionTypes.SET_PIN_APPLICATION, pinApplicationSaga),
  ]);
}
